import { render, staticRenderFns } from "./Modal_primary.vue?vue&type=template&id=00d1629a&scoped=true&"
import script from "./Modal_primary.vue?vue&type=script&lang=js&"
export * from "./Modal_primary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00d1629a",
  null
  
)

export default component.exports